<template>
    <div class="footer">
        <div class="colums_by_half">
            <div class="column">
                <ul>
                    <li>
                        <router-link to="/main">Личный кабинет</router-link>
                    </li>
                    <li>
                        <router-link to="/orders">Заказы</router-link>
                    </li>
                    <li>
                        <router-link to="/search">Поиск товаров</router-link>
                    </li>
                    <li>
                        <router-link to="/promo">Акции</router-link>
                    </li>

                    <li>
                        <router-link to="/basket">Корзина</router-link>
                    </li>

                    <div v-if="this.userStore.user.oth.length>0">

                        <li>
                            <router-link to="/basket_oth">Реализация ОТХ</router-link>
                        </li>

                        <li>
                            <a href="/b2b/oth_help" target="_blank">Инструкции ОТХ</a>
                        </li>

                    </div>


                </ul>
                <ul>
                    <li><a href="/">Главная</a></li>
                    <li><a href="/static/about">О компании</a></li>
                    <li><a href="/news">Новости</a></li>
                    <li><a href="/static/ourchain">Наша сеть</a></li>
                    <li><a href="/static/brands">Официальные дилеры</a></li>
                    <li><a href="/static/client">Партнерам</a></li>
                    <li><a href="/b2b/feedback">Обратная связь</a></li>

                </ul>
            </div>

            <div class="column space_b">
                <div class="contacts">
                    <a v-bind:href="dicStore.ui_el.results[13].properties.link.value" class="phone">{{ dicStore.ui_el.results[13].properties.txt.value }}</a>
                    <a v-bind:href="dicStore.ui_el.results[15].properties.link.value" class="mail">{{ dicStore.ui_el.results[15].properties.txt.value }}</a>
                    <div class="adress" v-html="dicStore.ui_el.results[13].properties.editor.value"></div>
                </div>
                <div class="copyright">
                    <a v-bind:href="dicStore.ui_el.results[16].properties.link.value">{{ dicStore.ui_el.results[16].properties.txt.value }}</a>
                    <div class="urname">{{ dicStore.ui_el.results[17].properties.txt.value }}</div>
                </div>
            </div>


        </div>
    </div>
</template>

<script>
import {useDicStore} from '@/stores/DicStore'
import {useUserStore} from '@/stores/UserStore'

export default {
    name: 'basement',
    setup() {
        const dicStore = useDicStore()
        const userStore = useUserStore()
        return {dicStore, userStore}
    },
    data: function () {
        return {
            expand: '',
        }
    },
    methods: {
        route_to(name) {

            try {
                this.$router.push({name: name})
            } catch (error) {
                if (!(error instanceof NavigationDuplicated)) {
                    //throw error;
                }
            }
        },
        set_expand(reffer) {
            if (this.expand !== reffer) {
                this.expand = reffer;
            } else {
                this.expand = '';
            }
        },
        switchExpands() {
            if (this.page.ui.show_menu == true) {
                this.hideExpands();
            } else {
                this.showExpands();
            }
        },
        showExpands() {
            this.page.ui.show_menu = true;
        },
        hideExpands() {
            this.page.ui.show_menu = false;
        },
    },
}
</script>

<style scoped>
.footer {
    background-color: #EAEAEA;
    display: flex;
    flex-direction: row;
    padding: 13px 75px 27px 80px;
    font-size: 16px;
    color: #666;
}

.footer a {
    color: #009ED5;
    text-decoration: none;
}

.footer ul {
    margin: 0 66px 0 0;
}

.footer ul li {
    line-height: 35px;
    padding: 0px;
    margin: 0px;
}

.footer .space_b {
    justify-content: space-between;
}

.footer .phone {
    font-weight: bold;
    font-size: 20px;
    color: #000;
    text-decoration: none;
    display: block;
    padding: 21px 0 7px 0;
}

.footer .mail {
    display: block;
}

.footer .adress {
    line-height: 27px;
    padding: 32px 0 0 0;
    font-size: 16px;
}

.footer .copyright {
    line-height: 27px;
    padding: 20px 0 0 0;
    width: 230px;
}


@media only screen and (max-width: 1200px) {

}
</style>
